/* unplugin-vue-components disabled */import { render } from "./dspc.vue?vue&type=template&id=25129cb8&scoped=true"
import script from "./dspc.vue?vue&type=script&lang=js"
export * from "./dspc.vue?vue&type=script&lang=js"

import "./dspc.vue?vue&type=style&index=0&id=25129cb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25129cb8"]])

export default __exports__